module.exports = __webpack_public_path__ + "media/images/landing/bg/case-nestle/blog-b15b5e39aca3d37bf5b05e806f2d2d68.png";